import type { ProjectGraphEdge, ProjectGraphNode, ProjectGraphResponse } from '@avisoma/shared';
import { indexOf } from './graphIndex';
import { linkedPageIds } from './mentionEvidence';

export type DocumentNode = Extract<ProjectGraphNode, { kind: 'document' }>;

/** The document nodes with no edge at either end, in graph order: documents that name no entity. */
export function unconnectedDocuments(graph: ProjectGraphResponse): DocumentNode[] {
  const { degree } = indexOf(graph);
  return graph.nodes.filter((n): n is DocumentNode => n.kind === 'document' && !degree.has(n.id));
}

/** DR-5201: curated reference edges, which no document states: `sources` is empty by design. */
const CURATED_EDGE_KINDS: ReadonlySet<ProjectGraphEdge['kind']> = new Set(['interfaces', 'kit']);

/** The edges with no linked source page in any of their sources, in graph order; curated edges are not evidence gaps. */
export function edgesWithoutPages(graph: ProjectGraphResponse): ProjectGraphEdge[] {
  return graph.edges.filter((e) => !CURATED_EDGE_KINDS.has(e.kind) && linkedPageIds(e).length === 0);
}
